import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { FloatFinanceService } from "../../services/FloatFinanceServices";


export const floatFinanaceAction = (data: any) => {
    const api = new FloatFinanceService().floatFinanceTable(data);
    return (dispatch: Dispatch) => {
        api
            .then((res: any) => {

                if (res) {

                    dispatch({
                        type: 'FINANCE_TABLE_DATA',

                        payload: {
                            message: res,
                            successful: true,
                        },
                    });
                } else {

                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: errorHandler(res),
                            successful: false,
                        },
                    });
                }
            })
            .catch(() => {
                // send err to application
                dispatch({
                    type: 'ALERT',
                    payload: {
                        message: 'Network request failed',
                        successful: false,
                    },
                });
            }).finally(() => {
                dispatch({
                    type: 'LOADING',
                    payload: false,
                });

            });
    };

};
export const recAndDeclinedAction = (data: any) => {
    const api = new FloatFinanceService().recommendAndDeclinedServices(data)

    // return (dispatch: Dispatch) => {

    //     return dispatch({
    //         type: "SEND_REC_AND_DECLINED_MESSAGE",
    //         payload: api
    //     })
    // }
    return (dispatch: Dispatch) => {

        api
            .then((res: any) => {

                if (res.successful) {

                    dispatch({
                        type: "SEND_REC_AND_DECLINED_MESSAGE",
                        payload: {
                            message: "successful",
                            successful: true,
                        },
                    });
                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: "Successful",
                            successful: true,
                        },
                    });

                } else {

                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: errorHandler(res),
                            successful: false,
                        },
                    });
                }
            })
            .catch(() => {
                // send err to application
                dispatch({
                    type: 'ALERT',
                    payload: {
                        message: 'Network request failed',
                        successful: false,
                    },
                });
            }).finally(() => {
                dispatch({
                    type: 'LOADING',
                    payload: false,
                });

            });
    };

};


export const getFloatRequestFilterDashboard = (data: any) => {
    const api = new FloatFinanceService().requestDashboardFloat(data);

    return (dispatch: Dispatch) => {

        api
            .then((res: any) => {
                if (res.successful) {
                    dispatch({
                        type: 'REQUEST_DASHBOARD',
                        payload: res.result,
                    });
                } else {

                    // dispatch({
                    //     type: 'ALERT',
                    //     payload: {
                    //         successful: false,
                    //         message: errorHandler(res)
                    //     }
                    // });

                    dispatch({
                        type: 'REQUEST_DASHBOARD',
                        payload: {},
                    });


                }
            })
            .catch(() => {
                // send err to application
                // dispatch({
                //     type: 'ALERT',
                //     payload: {
                //         message: 'Network request failed',
                //         successful: false,
                //     },
                // });
                dispatch({
                    type: 'REQUEST_DASHBOARD',
                    payload: {},
                });
            }).finally(() => {
                dispatch({
                    type: 'LOADING',
                    payload: false,
                });

                dispatch({
                    type: "INTERNAL_LOADER",
                    payload: false
                });

            });
    };
};

export const confirmPaymentAction = (data: any) => {
    const api = new FloatFinanceService().confirmPaymentServices(data)

    // return (dispatch: Dispatch) => {

    //     return dispatch({
    //         type: "SEND_REC_AND_DECLINED_MESSAGE",
    //         payload: api
    //     })
    // }
    return (dispatch: Dispatch) => {

        api
            .then((res: any) => {

                if (res.successful) {

                    dispatch({
                        type: "SEND_REC_AND_DECLINED_MESSAGE",
                        payload: {
                            message: errorHandler(res),
                            successful: true,
                        },
                    });
                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: errorHandler(res),
                            successful: true,
                        },
                    });

                } else {

                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: errorHandler(res),
                            successful: false,
                        },
                    });
                }
            })
            .catch(() => {
                // send err to application
                dispatch({
                    type: 'ALERT',
                    payload: {
                        message: 'Network request failed',
                        successful: false,
                    },
                });
            }).finally(() => {
                dispatch({
                    type: 'LOADING',
                    payload: false,
                });

            });
    };

};
export const remindAgentAction = (data: any) => {
    const api = new FloatFinanceService().remindAgentServices(data)

    return (dispatch: Dispatch) => {

        api
            .then((res: any) => {

                if (res.successful) {

                    dispatch({
                        type: "SEND_REC_AND_DECLINED_MESSAGE",

                        payload: {
                            message: "Success",
                            successful: true,
                        },
                    });
                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: errorHandler(res),
                            successful: true,
                        },
                    });

                } else {

                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: errorHandler(res),
                            successful: false,
                        },
                    });
                }
            })
            .catch(() => {
                // send err to application
                dispatch({
                    type: 'ALERT',
                    payload: {
                        message: 'Network request failed',
                        successful: false,
                    },
                });
            }).finally(() => {
                dispatch({
                    type: 'LOADING',
                    payload: false,
                });

            });
    };

};

export const getFloatFinanaceActionDetails = (id: any) => {
    const api = new FloatFinanceService().getFloatFinanceDetailsById(id);

    return (dispatch: Dispatch) => {

        api
            .then((res: any) => {
                if (res) {
                    dispatch({
                        type: 'FLOAT_FINANCE_DETAILS',
                        payload: res.result,
                    });
                } else {
                    dispatch({
                        type: 'ALERT',
                        payload: {
                            message: 'Network request failed',
                            successful: false,
                        },
                    });
                }
            })
            .catch(() => {
                // send err to application
                dispatch({
                    type: 'ALERT',
                    payload: {
                        message: 'Network request failed',
                        successful: false,
                    },
                });
            }).finally(() => {
                dispatch({
                    type: 'LOADING',
                    payload: false,
                });

            });
    };
};

export const floatActionFilterDaysAction = (data: any) => {
    const api = new FloatFinanceService().floatActionFilterDaysServices(data)

    return (dispatch: Dispatch) => {

        return dispatch({
            type: "GET_DAYS_FILTER",
            payload: api
        })
    }

};
